import React, { useRef } from 'react'

import Table from '@ui/Table'
import TableCell from './TableCell'
import { EditAction, GraphicAction, RemoveAction } from './Actions'
import Filter from '../Filter'

import { alphaSorting, notAlphaSorting } from '@models/sorting'

import { useRouter } from '@contexts/RouterProvider'

export const CustomTable = ({
  orderBy,
  describer,
  sortedData,
  getManagementStatusButton,
  setSortedData,
  availableDates,
  handleOpenDialog,
  running,
  hasNoRunningData,
  initialSwitchValue,
  isShowingRunningWithoutData
}) => {
  const tableRef = useRef(null)
  const router = useRouter()

  const setTablePage = () => !!tableRef.current && tableRef.current.dataManager.changeCurrentPage(0)

  const handleTableFilter = (values) => {
    const isFinished = values.showFinishedManagements

    if (hasNoRunningData || isFinished) {
      setTablePage()
      setSortedData(values)
      return
    }

    const data = running.content[values.date]

    if (values.orderBy === 'alpha') {
      data.sort((a, b) => alphaSorting(a, b, values))
    } else if (values.orderBy) {
      data.sort((a, b) => notAlphaSorting(a, b, values))
    }

    setTablePage()
    setSortedData(values)
  }

  return (
    <>
      <Filter
        orderBy={orderBy}
        availableDates={availableDates}
        setSortedData={handleTableFilter}
        initialSwitchValue={initialSwitchValue}
      />

      {isShowingRunningWithoutData ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
          {I18n.t('v4/irrigation_management.no_managements')}
        </div>
      ) : (
        <Table
          tableRef={tableRef}
          key='equipment-table'
          components={{
            Container: props => <div>{props.children}</div>,
            Cell: props => <TableCell {...props} />
          }}
          columns={describer}
          data={sortedData}
          options={{
            showTitle: false,
            search: false
          }}
          actions={[
            rowData => GraphicAction(rowData, router),
            rowData => EditAction(rowData, router),
            rowData => getManagementStatusButton(rowData),
            rowData => RemoveAction(rowData, id => handleOpenDialog(id))
          ]}
          tableKey='irrigationManagementIndexTable'
        />
      )}
    </>
  )
}
